import { StatusAborted, StatusOK } from '@backstage/core-components';
import { Typography } from '@material-ui/core';

interface StatusIndicatorTitleProps {
  enabled?: boolean;
  title: string;
}

export const StatusIndicatorTitle = ({
  enabled,
  title,
}: StatusIndicatorTitleProps) =>
  enabled ? (
    <StatusOK>
      <Typography variant="h6">{title}</Typography>
    </StatusOK>
  ) : (
    <StatusAborted>
      <Typography variant="h6">{title}</Typography>
    </StatusAborted>
  );
